import { __rest, __assign } from 'tslib';
import React, { forwardRef, useRef } from 'react';
import mergeRefs from 'react-merge-refs';
import cn from 'classnames';
import { dom } from '@alfalab/core-components-shared/esm';
import { useFocus } from '@alfalab/hooks';
import { CheckIcon } from './icon.js';

var defaultColors = {"box":"checkbox__box_1pby7","checkedIcon":"checkbox__checkedIcon_1pby7","component":"checkbox__component_1pby7","disabled":"checkbox__disabled_1pby7","checked":"checkbox__checked_1pby7","indeterminate":"checkbox__indeterminate_1pby7","indeterminateLine":"checkbox__indeterminateLine_1pby7","label":"checkbox__label_1pby7","hint":"checkbox__hint_1pby7"};
require('./styles/default.css')

var styles = {"component":"checkbox__component_1azyd","start":"checkbox__start_1azyd","center":"checkbox__center_1azyd","addons":"checkbox__addons_1azyd","block":"checkbox__block_1azyd","box":"checkbox__box_1azyd","checkedIcon":"checkbox__checkedIcon_1azyd","size-20":"checkbox__size-20_1azyd","disabled":"checkbox__disabled_1azyd","focused":"checkbox__focused_1azyd","content":"checkbox__content_1azyd","label":"checkbox__label_1azyd","errorMessage":"checkbox__errorMessage_1azyd","hint":"checkbox__hint_1azyd","indeterminateLine":"checkbox__indeterminateLine_1azyd"};
require('./styles/index.css')

var invertedColors = {"box":"checkbox__box_iq9ck","checkedIcon":"checkbox__checkedIcon_iq9ck","component":"checkbox__component_iq9ck","disabled":"checkbox__disabled_iq9ck","checked":"checkbox__checked_iq9ck","indeterminate":"checkbox__indeterminate_iq9ck","indeterminateLine":"checkbox__indeterminateLine_iq9ck","label":"checkbox__label_iq9ck","hint":"checkbox__hint_iq9ck"};
require('./styles/inverted.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var SIZE_TO_CLASSNAME_MAP = {
    s: 'size-20',
    m: 'size-24',
    20: 'size-20',
    24: 'size-24',
};
var Checkbox = forwardRef(function (_a, ref) {
    var _b;
    var checked = _a.checked, label = _a.label, hint = _a.hint, _c = _a.size, size = _c === void 0 ? 20 : _c, boxClassName = _a.boxClassName, contentClassName = _a.contentClassName, _d = _a.align, align = _d === void 0 ? 'start' : _d, addons = _a.addons, block = _a.block, onChange = _a.onChange, className = _a.className, name = _a.name, disabled = _a.disabled, inactive = _a.inactive, dataTestId = _a.dataTestId, _e = _a.indeterminate, indeterminate = _e === void 0 ? false : _e, _f = _a.hiddenInput, hiddenInput = _f === void 0 ? false : _f, labelProps = _a.labelProps, error = _a.error, inputRef = _a.inputRef, _g = _a.colors, colors = _g === void 0 ? 'default' : _g, restProps = __rest(_a, ["checked", "label", "hint", "size", "boxClassName", "contentClassName", "align", "addons", "block", "onChange", "className", "name", "disabled", "inactive", "dataTestId", "indeterminate", "hiddenInput", "labelProps", "error", "inputRef", "colors"]);
    var labelRef = useRef(null);
    var focused = useFocus(labelRef, 'keyboard')[0];
    var handleChange = function (event) {
        if (onChange) {
            onChange(event, { checked: event.target.checked, name: name });
        }
    };
    var errorMessage = typeof error === 'boolean' ? '' : error;
    var colorStyle = colorStyles[colors];
    return (React.createElement("label", __assign({}, labelProps, { className: cn(styles.component, colorStyle.component, styles[SIZE_TO_CLASSNAME_MAP[size]], styles[align], className, labelProps === null || labelProps === void 0 ? void 0 : labelProps.className, (_b = {},
            _b[styles.disabled] = disabled || inactive,
            _b[colorStyle.disabled] = disabled || inactive,
            _b[styles.checked] = checked,
            _b[colorStyle.checked] = checked,
            _b[styles.indeterminate] = indeterminate,
            _b[colorStyle.indeterminate] = indeterminate,
            _b[styles.focused] = focused,
            _b[styles.block] = block,
            _b)), ref: mergeRefs([labelRef, ref, labelProps === null || labelProps === void 0 ? void 0 : labelProps.ref]) }),
        !hiddenInput && (React.createElement("input", __assign({ type: 'checkbox', onChange: handleChange, name: name, disabled: disabled || inactive, checked: checked, "data-test-id": dataTestId, ref: inputRef }, restProps))),
        React.createElement("span", { className: cn(styles.box, colorStyle.box, boxClassName) },
            checked && (React.createElement(CheckIcon, { className: cn(styles.checkedIcon, colorStyle.checkedIcon) })),
            indeterminate && !checked && (React.createElement("span", { className: cn(styles.indeterminateLine, colorStyle.indeterminateLine) }))),
        (label || hint || errorMessage) && (React.createElement("span", { className: cn(styles.content, contentClassName) },
            label && (React.createElement("span", { className: cn(styles.label, colorStyle.label) }, label)),
            hint && !errorMessage && (React.createElement("span", { className: cn(styles.hint, colorStyle.hint) }, hint)),
            errorMessage && (React.createElement("span", { className: styles.errorMessage, role: 'alert' }, errorMessage)))),
        addons && (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        React.createElement("span", { className: styles.addons, onClick: dom.preventDefault }, addons))));
});
/**
 * Для отображения в сторибуке
 */
Checkbox.defaultProps = {
    indeterminate: false,
};
Checkbox.displayName = 'Checkbox';

export { Checkbox };
